<!--
  @deprecated This offer modal is part of the old offer system that is being rebuilt.
  Do not use or modify this component.
-->
<template>
  <b-modal
    v-if="lobbyOffer"
    id="modal-offer-spring-1"
    class="custom-modal1"
    :hide-footer="true"
    modal-class="custom-modal1"
    @hidden="onHidden"
  >
    <template slot="modal-header" slot-scope="{ close }">
      <a href="#" class="close-button" @click="close()"> </a>
    </template>

    <template slot="default">
      <div
        id="modal-spring-bg"
        class="dead-center w-100 h-100 bg-img"
        :class="$store.state.locale"
      ></div>
      <div
        v-if="rewards[0]"
        class="offer-reward-container position-absolute container"
      >
        <div class="h-100">
          <div
            class="w-100 d-flex flex-column align-items-center p-0"
            :style="{ visibility: rewards[0].gold > 0 ? 'visible' : 'hidden' }"
          >
            <div
              class="three-coins bg-img"
              :style="{ backgroundImage: 'url(' + tripleCoinUrl + ')' }"
            ></div>
            <div class="amount-gold yellow-text text-center w-100">
              {{ formatNumber(rewards[0].gold) }}
            </div>
          </div>

          <div v-if="rewards[0].card > 0" class="w-50 package-bonus-icons">
            <div class="yellow-text bold">
              {{ formatNumber(rewards[0].card) }} x
            </div>

            <BaseAsset asset="cards" size="big" class="ms-2 yellow-text" />
          </div>

          <div v-if="rewards[0].loyalty > 0" class="w-50 package-bonus-icons">
            <div class="yellow-text bold">
              {{ formatNumber(rewards[0].loyalty) }} x
            </div>

            <BaseAsset asset="loyalty" size="big" class="ms-2 yellow-text" />
          </div>
          <div
            v-if="rewards[0].crown > 0"
            cols="6"
            class="package-bonus-icons p-0"
          >
            <span class="yellow-text bold">
              {{ formatNumber(rewards[0].crown) }} x
            </span>

            <BaseAsset asset="secondary" size="big" class="ms-2 yellow-text" />
          </div>
        </div>
      </div>

      <div
        class="submit-button position-absolute bg-img px-3"
        @click="buyItem(0, 'Offer', 'Event', closeThisModal)"
      >
        <div
          class="d-inline-flex align-items-center justify-content-around w-100"
        >
          {{ $t("shop.offers.buy_today") }}
          <span class="big position-relative"
            >{{ formatPrice(price[0]) }} €

            <div
              v-if="oldPrices && oldPrices[0]"
              class="offer-old-price ms-3 right"
            >
              {{ formatPrice(oldPrices[0]) }} €
              <div class="offer-red-line to-center-abs"></div>
            </div>
            <div
              v-if="moreContent && moreContent[0]"
              class="big-badge-more-percent smaller"
            >
              <span class="big">{{ moreContent[0] }}</span>
              {{ $t("shop.offers.more_contents2") }}
            </div>
          </span>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import offerModalContent from "@/mixins/offerModalContent.js";
import BaseAsset from "@/components/base/base-asset.vue";

export default {
  name: "ModalOfferSpring1",
  components: {
    BaseAsset,
  },
  mixins: [offerModalContent],
  data() {
    return { isPipelineOffer: true };
  },
  computed: {
    tripleCoinUrl() {
      return this.$whitelabel.currencies.primary.triple;
    },
  },
  mounted: function () {
    this.$bvModal.show("modal-offer-spring-1");
  },
};
</script>
<style lang="scss">
$modal-width: 967px;
$modal-height: 630px;

#modal-offer-spring-1 {
  .modal-dialog {
    top: 50px;
    max-width: $modal-width;
    height: $modal-height;

    @media (max-height: 750px) {
      transform: scale(0.8);
      top: -60px;
    }
  }

  .modal-content {
    width: $modal-width;
    background-color: transparent;

    .modal-body {
      #modal-spring-bg {
        &.de {
          background-image: url(~@/assets/img/shop/offers/spring-DE.png);
        }
        &.en {
          background-image: url(~@/assets/img/shop/offers/spring-EN.png);
        }
      }
    }
  }

  .close-button {
    top: 0px;
    right: 0px;
  }
}
</style>

<style scoped lang="scss">
#modal-offer-spring-1 {
  .offer-reward-container {
    top: 190px;
    right: 107px;
    height: 257px;
    line-height: 1;
    width: 314px;
  }

  .three-coins {
    width: 185px;
    height: 116px;
  }
  .amount-gold {
    font-size: 56px;
    font-family: Ubuntu-Bold;
    position: relative;
    display: inline-flex;
    text-align: center;
    padding-right: 70px;
    margin-top: 10px;
  }

  .package-bonus-icons {
    display: inline-flex;
    align-items: center;
    height: 56px;
    font-size: 16px;
    .yellow-text {
      font-size: 32px;
    }
  }

  .submit-button {
    width: 387.4px;
    height: 139.4px;
    left: 62px;
    bottom: 0;
    font-size: 18px;
    padding-top: 40px;
    color: white;
    text-transform: uppercase;
    cursor: pointer;
    font-family: Ubuntu-Bold;
    line-height: 1.2;
    text-shadow: 1px 2px 4px $text-shadow-dark-green;
    background-image: url(~@/assets/img/shop/offers/button-green.png);

    .big {
      color: white;
      font-family: Ubuntu-Bold;
      font-size: 42px;
      text-shadow: 1px 2px 4px $text-shadow-dark-green;
    }

    .offer-old-price {
      top: -55px;
      right: -80px;
    }

    .big-badge-more-percent {
      top: -470px;
      right: -560px;
    }
  }
}
</style>
